module.exports = __webpack_public_path__ + "static/media/MTL_ASC_SPC1.24a8736f.png";